interface PromoBannerProps {
    text?: string;
}

const PromoBanner = ({ text }: PromoBannerProps) => {
    if (!text) return null;

    return (
        <div className="w-full h-[48px] bg-[#667085] text-[#F2F9FF] px-[32px] py-[12px] flex items-center justify-center border-b border-[#7F56D9]">
            <div className="w-[348px] text-sm font-medium tracking-normal flex justify-center text-center whitespace-nowrap">
                {text}
            </div>
        </div>
    );
};

export default PromoBanner;
